const filterStyle = {
  width: "150px",
  minWidth: "150px",
  maxWidth: "150px",
  height: "38px",
  boxSizing: "border-box",
  padding: "8px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  backgroundColor: "#fff",
  fontSize: "13px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const filterWrapperStyle = {
  position: "relative",
  width: "150px",
  minWidth: "150px",
  maxWidth: "150px",
  height: "38px",
  boxSizing: "border-box",
};

export {
  filterStyle,
  filterWrapperStyle
};